/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import produce from 'immer';

export default {
  state: {}, // initial state
  reducers: {
    openCodeEditorModal(state, payload) {
      return produce(state, (draft) => {
        draft.codeEditorModal = {
          options: payload.options,
          code: payload.code,
          onSave: payload.onSave,
          onClose: payload.onClose
        };
      });
    },

    closeCodeEditorModal(state) {
      return produce(state, (draft) => {
        delete draft.codeEditorModal;
      });
    },

    openDataElementSelectorModal(state, payload) {
      return produce(state, (draft) => {
        draft.dataElementSelectorModal = {
          options: payload.options,
          onSave: payload.onSave,
          onClose: payload.onClose
        };
      });
    },

    closeDataElementSelectorModal(state) {
      return produce(state, (draft) => {
        delete draft.dataElementSelectorModal;
      });
    }
  }
};
